<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="customer-receipt"
    :data-model="dataModel"
    :backRouteAppend="undefined"
    :isLoaded="loaded"
    :getHeaderToolbar="this.getHeaderToolbar"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { SupplierInvoiceService } from "../../_services/api/purchasing/supplier-invoice.service";
import CheckBox from "devextreme/ui/check_box";
import { mapGetters } from "vuex";
import { CustomerReceiptService } from "../../_services/api/customers/customer-receipt-service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { FactorService } from "../../_services/api/sales/factor.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      IsSettlementDateEnforced: undefined,
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      InvoiceNumber: undefined,
      discountPercentage: undefined,
      dataModel: {
        Allocated: undefined,
        Balance: undefined,
        MinDate: undefined,
        MaxDate: undefined,
        AccountingPeriod: undefined,
        Date: Date.now(),
        DueDate: undefined,
        PaymentMethods: undefined,
        PaymentMethod: undefined,
        BankAccountCode: undefined,
        BankAccount: undefined,
        DateDeposited: undefined,
        Customer: undefined,
        Payer: undefined,
        Currency: undefined,
        ExchangeRate: undefined,
        footerBalance: undefined,
        footerAllocated: undefined,
        Amount: 0.0,
        Rounding: 0.0,
        CustomerCode: undefined,
        minDate: undefined,
        AccountingPeriodCode: undefined,
        BillToCustomer: undefined,
        BranchCode: undefined,
        CompanyCode: undefined,
        DivisionCode: undefined,
      },
      reload: false,
      bankAcounts: undefined,
      isDueDateAvailable: false,
      validationSummary: [],
      cancelCompleteMenu: [],
      serverError: {},
      model: undefined,
      status: undefined,
      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
      },
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      const { from: parentPage } = this.baseView.query;
      if (parentPage == "customer-list") {
        return "/customer";
      } else if (parentPage == "customer-detail") {
        return "/customer/review/" + this.baseView.id;
      } else if (parentPage == "invoice-order-list") {
        return "/invoiced-order";
      } else {
        return "/invoiced-order";
      }
    },

    getScreenJson() {
      var screenJson = {
        title: "Create Customer Receipt",
        endpoint: this.isReviewMode()
          ? {
              primary: "CashReceipt",
              expand: "Customer($select=Name)",
              postProcess: this.cashReceiptPostProcess,
            }
          : { primary: undefined },
        headerData: {
          headerToolbar: {
            screenName: "Customer Receipt",
            pdf: this.isReviewMode(),
            audit: false,
            status: this.isReviewMode(),
            notes: false,
            save: this.baseView.mode == "create",

            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {},
                  },
                ],
              },
            ],
            deliveryAddressItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "DeliveryAddressCompanyName",
                    editorType: "dxTextBox",
                    label: {
                      text: "Name",
                    },
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressStreetLine1",
                    dataField: "DeliveryAddressStreetLine1",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressStreetLine2",
                    dataField: "DeliveryAddressStreetLine2",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressSuburb",
                    dataField: "DeliveryAddressSuburb",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressState",
                    dataField: "DeliveryAddressState",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressPostcode",
                    dataField: "DeliveryAddressPostcode",
                    // allowUpdate: false,
                  },
                  {
                    screenField: "PhysicalAddressCountry",
                    dataField: "DeliveryAddressCountry",
                    // allowUpdate: false,
                  },
                ],
              },
            ],
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "Date",
                      editorOptions: {
                        min: this.dataModel.minDate,
                        allowUpdate: !this.isReviewMode(),
                        onValueChanged: (e) => {
                          this.receiptCreatedDateChanged(e);
                        },
                      },
                      label: {
                        text: "Date",
                      },
                      validationRules: [
                        {
                          type: "required",
                          message: "Date is required",
                        },
                      ],
                    },
                    {
                      screenField: "PaymentMethod",
                      dataField: this.isReviewMode()
                        ? "PaymentMethod"
                        : "PaymentMethods",
                      required: true,
                      label: {
                        text: "Payment Method",
                      },
                      defaultValue: this.dataModel.PaymentMethod,
                      editorOptions: {
                        allowUpdate: !this.isReviewMode(),
                        onValueChanged: (e) => {
                          this.PaymentMethodsChanged(e);
                        },
                      },
                    },
                    {
                      screenField: "BankAccount",
                      dataField: this.isReviewMode()
                        ? "BankAccount"
                        : "BankAccountCode",
                      defaultValue: `${this.dataModel.BankAccountCode}`,
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "Date",
                      dataField: "DateDeposited",
                      allowUpdate: true,
                      label: {
                        text: "Date Deposited",
                      },
                    },
                    {
                      screenField: "Date",
                      dataField: "DueDate",
                      allowUpdate: true,

                      visible: !this.isReviewMode(),
                      label: {
                        text: "Due Date",
                      },
                    },
                    {
                      screenField: "Customer",
                      dataField: "Customer",
                      allowUpdate: false,
                      label: {
                        Text: "Customer",
                      },
                    },
                    {
                      screenField: "Payer",
                      dataField: "Payer",
                      allowUpdate: true,
                      label: {
                        text: "Payer",
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "Currency",
                      allowUpdate: false,
                      label: {
                        text: "Currency",
                      },
                    },
                    {
                      screenField: "ExchangeRate",
                      dataField: "ExchangeRate",
                      allowUpdate: this.dataModel.Currency != "AUD",
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: ({ value, rule }) => {
                            rule.message = `Exchange rate Cannot be 0 or Negative`;
                            return value > 0;
                          },
                        },
                      ],
                    },
                    {
                      screenField: "FXAmount",
                      dataField: "FXIncTaxAmount",
                      editorOptions: {
                        onValueChanged: (e) => {
                          this.amountValueChange(e);
                        },
                      },
                      label: {
                        text: "Amount(" + this.getCurrencyCode + ")",
                      },
                      validationRules: [
                        {
                          type: "required",
                          message: "Amount is required",
                        },
                      ],
                    },
                    {
                      screenField: "Rounding",
                      dataField: "FXVarianceRounding",
                      editorOptions: {
                        onValueChanged: (e) => {
                          this.roundingValueChange(e);
                        },
                      },

                      label: {
                        text: "Rounding(" + this.getCurrencyCode + ")",
                      },
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: "Customer",
                text: `${
                  this.isReviewMode() ? "" : "Create"
                } Customer Receipt for `,
              },
              secondary: {},
            },
            secondary: {},
          },
        },
        gridData: {
          gridOptions: {
            dataSource: this.isReviewMode()
              ? {
                  endpoint: "CashReceiptDetail",
                  filter: ["CashReceiptCode eq " + this.baseView.id],
                  serverPaging: true,
                  allowGrouping: false,
                  // expand: "SaleItem",
                  postProcessCallback: this.CashReceiptDetailPostProcess,
                }
              : {
                  endpoint: "OutstandingCustomerInvoice",
                  filter: this.isNavigatedFromCutomerPage()
                    ? [
                        `CustomerCode eq '${this.baseView.id}' ${
                          this.dataModel.DueDate
                            ? `and CalculatedDueDate le ${new Date(
                                this.dataModel.DueDate
                              ).toFilterDateString()}`
                            : ""
                        }`,
                      ]
                    : [
                        `CustomerCode eq '${this.baseView.id}' ${
                          this.dataModel.DueDate
                            ? `and CalculatedDueDate le ${new Date(
                                this.dataModel.DueDate
                              ).toFilterDateString()}`
                            : ""
                        } and RefNo eq '${this.baseView.query.invoiceNumber}'`,
                      ],
                  serverPaging: true,
                  allowGrouping: false,
                  postProcessCallback: this
                    .createCustomerReceiptDetailPostProcess,
                },
          },
          toolbar: {
            search: this.isReviewMode,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: false,
          },
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              width: 50,
              minWidth: 50,
              visible: !this.isReviewMode(),
              cssClass: "check-include",
            },
            {
              screenField: "Invoice",
              allowHiding: false,
              dataField: "RefNo",
            },
            {
              screenField: "InvoiceDate",
              minWidth: "auto",
              dataField: "DateIn",
            },
            {
              screenField: "DueDate",
              dataField: "CalculatedDueDate",
              visible: !this.isReviewMode(),
            },
            {
              screenField: "SalesOrder",
              label: "Sales Order",
              dataField: "SalesOrder",
            },
            {
              screenField: "CustomerPO",
              label: "Customer PO",
              dataField: "CustomerOrder",
            },
            {
              screenField: "FXBalance",
              dataField: "FXBalance",
              type: "Decimal",
              showEditorAlways: true,
              allowEditing: false,
            },
            {
              screenField: "FXDiscount",
              dataField: "FXDiscountReceived",
              label: "Discount",
              type: "EditableDecimal",
              showEditorAlways: true,
              allowEditing: this.dataModel.Currency === "AUD" ? false : true,
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
            },
            {
              screenField: "FXAllocation",
              dataField: "AllocatedAmount",
              type: "EditableDecimal",
              allowEditing: true,
              showEditorAlways: true,
              makeDisabled: (data) => {
                if (data.data.CheckInclude == true) {
                  return false;
                } else return true;
              },
              format: "Decimal-16-2C",
            },
          ],

          valueChangedEventListners: [
            {
              dataField: "FXBalance",
              listner: (e, lineData) => {
                lineData.data.Balance = e.value;
                lineData.data.AllocatedAmount =
                  e.value - lineData.data.DiscountReceived;
                this.mergeWithReviewView(
                  lineData.data.Balance == 0 ? false : true,
                  lineData.data
                );
              },
            },
            {
              dataField: "FXDiscountReceived",
              listner: (e, lineData) => {
                if (e.value >= 0) {
                  lineData.data.DiscountReceived = e.value;
                  lineData.data.AllocatedAmount =
                    lineData.data.Balance - e.value;
                  this.mergeWithReviewView(
                    lineData.data.DiscountReceived == 0 ? false : true,
                    lineData.data
                  );
                } else {
                  lineData.data.DiscountReceived = 0;
                  // this.validationSummary = [];
                  // this.validationSummary.push({
                  //   message: "Discount Cannot be Negative",
                  // });
                  this.doValidation("Discount Cannot be Negative");
                  this.mergeWithReviewView(
                    lineData.data.DiscountReceived == 0 ? false : true,
                    lineData.data
                  );
                }
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "Allocated",
              location: "right",
              value: 0,
              label: "Allocated(" + this.getCurrencyCode + ")",
              customCalc: (headerData, gridItems) => {
                return this.onCustomCalcAllocationAmountChanged(
                  headerData,
                  gridItems
                );
              },
              format: "Decimal-16-2C",
            },
            {
              screenField: "Balance",
              location: "right",
              label: "Balance(" + this.getCurrencyCode + ")",
              allowEditing: false,
              customCalc: (headerData, gridItems) => {
                return this.onCustomCalcBalance(headerData, gridItems);
              },
              format: "Decimal-16-2C",
            },
          ],
        },
      };
      return screenJson;
    },
    getCurrencyCode() {
      if (this.dataModel.Currency) return this.dataModel.Currency;
      else return "";
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          save: this.baseView.mode == "create",
          saveCallback: this.saveCustomerReceipt,
          customButtons: [
            {
              label: "save",
              icon: "..",
              type: " ",
              click: "",
              menu: [
                {
                  label: "Credit Comments",
                  clickAction: "",
                },
              ],
            },
          ],
        },
      };
    },
  },
  methods: {
    doValidation(msg) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: msg,
      });
    },
    receiptCreatedDateChanged({ value }) {
      this.dataModel.Date = value;
    },
    CashReceiptDetailPostProcess(data) {
      data.forEach((element) => {
        element["RefNo"] = element.Invoice;
        element["DateIn"] = element.Date;
        element["CalculatedDueDate"] = element.DateChanged;
        // element["SalesOrder"] = element.SalesOrder;
        // element["CustomerOrder"] = element.CustomerOrder;
        // element["Balance"] = element.Balance;
        element["FXDiscountReceived"] = element.FXDiscount;
        element["AllocatedAmount"] = element.FXAllocation;
      });
      return data;
    },
    isReviewMode() {
      return this.baseView.mode === "review";
    },
    cashReceiptPostProcess(data) {
      this.dataModel.PaymentMethod = data.PayMethod;
      this.dataModel.BankAccount = data.BankAccount;
      this.dataModel.DateDeposited = data.Deposited;
      this.dataModel.Customer = data.Customer.Name;
      this.dataModel.Payer = data.PayeeName;
      this.dataModel.Currency = data.CurrencyCode;
      this.dataModel.ExchangeRate = data.RateVariance;
      this.dataModel.FXIncTaxAmount = data.Amount;
      this.dataModel.FXVarianceRounding = data.Rounding;
      return data;
    },
    PaymentMethodsChanged({ value }) {
      this.dataModel.PaymentMethod = value;
    },
    onCustomCalcBalance(headerData, gridItems) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element.AllocatedAmount;
      });
      total = headerData.Amount - (total + headerData.Rounding);
      this.dataModel.footerBalance = total;
      return total;
    },
    onCustomCalcAllocationAmountChanged(headerData, gridItems) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element.AllocatedAmount;
      });
      this.dataModel.footerAllocated = total;
      return total;
    },
    isNavigatedFromCutomerPage() {
      const { from } = this.baseView.query;
      return from == "customer-list" || from == "customer-detail";
    },
    getTotalOfGridFields(gridItems, propertyName) {
      var total = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) total = total + element[propertyName];
      });
      return total;
    },

    async initialized() {
      this.InvoiceNumber = this.baseView.query.invoiceNumber;
      // this.reload = false;
      this.setLoading = true;
      if (!this.isReviewMode()) {
        await DefaultCompanyBranchDivisionService.getDefault().then(
          ({ data }) => {
            this.dataModel.BranchCode = data.value[0].BranchCode;
            this.dataModel.CompanyCode = data.value[0].CompanyCode;
            this.dataModel.DivisionCode = data.value[0].DivisionCode;
          }
        );
        await CustomerReceiptService.getCurrentAccountingPeriodCode()
          .then(({ data }) => {
            this.dataModel.AccountingPeriodCode =
              data.value[0].AccountingPeriodCode;
            CustomerReceiptService.getCurrentAccountingPeriod(
              data.value[0].AccountingPeriodCode
            )
              .then(({ data }) => {
                this.dataModel.minDate = data.value[0].DateStart;
              })
              .catch();
          })
          .catch();
        if (this.isNavigatedFromCutomerPage()) {
          await CustomerService.getByCode(this.baseView.id).then(
            async ({ data }) => {
              this.dataModel.BillToCustomer = data.value[0].BillToCustomerCode;
              this.dataModel.CustomerCode = data.value[0].Code;

              this.dataModel.Currency = data.value[0].CurrencyCode;
              await CustomerService.getByCode(data.value[0].BillToCustomerCode)
                .then(({ data }) => {
                  this.dataModel.Customer = data.value[0].Name;
                  this.dataModel.Payer = data.value[0].Name;
                })
                .catch();
            }
          );
        } else {
          await CustomerService.getCustomerByCustomerCode(this.baseView.id)
            .then(async ({ data }) => {
              this.dataModel.BillToCustomer = data.value[0].BillToCustomerCode;
              this.dataModel.CustomerCode = data.value[0].CustomerCode;
              this.dataModel.Currency = data.value[0].CurrencyCode;
              await CustomerService.getByCode(data.value[0].BillToCustomerCode)
                .then(({ data }) => {
                  this.dataModel.Customer = data.value[0].Name;
                  this.dataModel.Payer = data.value[0].Name;
                })
                .catch();
            })
            .catch();
        }

        await CustomerReceiptService.getPaymentMethods().then(
          ({ data }) => {
            var PaymentMethods = data.value;
            this.dataModel.PaymentMethods = PaymentMethods;
            this.dataModel.PaymentMethod = data.value.filter(
              (val) => val.isDefault === 1
            )[0].PayDesc;
          }
        );

        await FactorService.getByCode(237).then(async ({ data }) => {
          this.dataModel.BankAccountCode = data.value[0].FactorInt;
        });
        await FactorService.getByCode(540).then(async ({ data }) => {
          this.IsSettlementDateEnforced = data.value[0].Factorc;
        });
        await CompanyCurrencyService.getByCurrencyCode(this.dataModel.Currency)
          .then(({ data }) => {
            this.dataModel.ExchangeRate = data.value[0].SellRate;
          })
          .catch();

        this.loaded = true;
      } else {
        setTimeout(() => {
          this.reload = false;
          this.loaded = true;
          this.setLoading = false;
        }, 250);
      }
      this.loaded = true;
    },
    async setDateInValidation() {
      var currentPaymentDate = undefined;
      if (this.isReviewMode())
        currentPaymentDate = new Date(this.dataModel.DateInto.replace("Z", ""));
      else currentPaymentDate = this.PaymentMinDate;

      let startDateResult = await SupplierInvoiceService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriodStartDate = new Date(
          startDateResult.data.value[0].StartDate.replace("Z", "")
        );

        if (
          this.isReviewMode() &&
          currentPaymentDate.getTime() > accountingPeriodStartDate.getTime()
        ) {
          this.PaymentMinDate = currentPaymentDate;
        } else {
          this.PaymentMinDate = accountingPeriodStartDate;
        }
      } else {
        this.PaymentMinDate = currentPaymentDate;
      }
    },

    checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) return;

      var gridItems = recordData.component.getDataSource().items();

      if (recordData.rowType == "header") {
        if (fieldData.value == undefined) return;
        else {
          gridItems.forEach((element) => {
            if (fieldData.value) {
              element.CheckInclude = true;
            } else {
              element.CheckInclude = false;
            }

            this.mergeWithReviewView(fieldData.value, element);
          });
        }
      } else {
        recordData.data.CheckInclude = fieldData.value;
        this.mergeWithReviewView(fieldData.value, recordData.data);
      }

      this.updateHeaderCheckBox(gridItems);
    },

    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.GoodsInCode == item.GoodsInCode && x.ItemCode == item.ItemCode
      );
      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
      }
    },

    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },

    addToReview(item) {
      item.CheckInclude = true;
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },

    updateHeaderCheckBox(gridItems) {
      var refHeadInstance = this.$refs["customer-receipt"].$refs[
        "transactionGrid"
      ].$refs["cx-CheckInclude"].getSeletcAllRef().instance;
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });

      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }
      }, 100);
    },
    roundingValueChange(e) {
      this.dataModel.Rounding = e.value;
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++
      );
    },
    amountValueChange(e) {
      this.dataModel.Amount = e.value;
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++
      );
    },

    async saveCustomerReceipt(data, gridItems) {
      var payload = {
        AccountPeriod: data.AccountingPeriodCode,
        Currency: data.Currency,
        Amount: data.Amount,
        PaymentMethod: data.PaymentMethod ? data.PaymentMethod : "",
        PayeeName: data.Payer,
        Rate: data.ExchangeRate,
        DateIn: new Date(data.Date),
        Rounding: data.Rounding,
        CustomerCode: this.dataModel.CustomerCode,
        DiscountAmount: this.getTotalOfGridFields(
          gridItems,
          "DiscountReceived"
        ),
        FXDiscount: this.getTotalOfGridFields(gridItems, "FXDiscountReceived"),
        CompanyCode: this.dataModel.CompanyCode,
        BranchCode: this.dataModel.BranchCode,
        DivisionCode: this.dataModel.DivisionCode,
        BankAccountCode: this.dataModel.BankAccountCode,
        ChequeNo: "",
        BSBNO: "",
        AccountNumber: "",
        FXAmount: this.getTotalOfGridFields(gridItems, "FXBalance"),
        FXRate: data.ExchangeRate,
        Deposited: data.DateDeposited,
        CustomerReceiptDetails: [],
      };
      gridItems.forEach((el) => {
        if (!el.CheckInclude) return;
        let obj = {
          Include: "Y",
          CalculateDiscount: this.IsSettlementDateEnforced,
          ARDataXref: String(el.ArdataCode),
          CustomerInvoice: el.RefNo,
          SalesOrder: parseInt(el.SalesOrder),
          CustomerOrder: el.CustomerOrder,
          InvoiceDate: new Date(el.DateIn),
          FXBalance: el.FXBalance,
          DiscountAmount: el.DiscountReceived,
          FXRate1: el.ExchangeRate,

          FXVar:
            parseFloat(data.ExchangeRate) == parseFloat(el.ExchangeRate)
              ? 0
              : (parseFloat(el.FXBalance) == parseFloat(el.FXAllocationAmount)
                  ? el.Balance -
                    (
                      el.FXAllocationAmount.roundNumber(2) / data.ExchangeRate
                    ).roundNumber(2)
                  : (
                      el.FXAllocationAmount.roundNumber(2) / el.ExchangeRate
                    ).roundNumber(2) -
                    (
                      el.FXAllocationAmount.roundNumber(2) / data.ExchangeRate
                    ).roundNumber(2)
                ).roundNumber(2),
          Allocation: (
            el.FXBalance.roundNumber(2) / el.ExchangeRate
          ).roundNumber(2),
          FXAllocation: el.AllocatedAmount,
          Currency: el.Currency,
          Balance: el.FXBalance,
          FXDiscount: el.FXDiscountReceived,
        };
        payload.CustomerReceiptDetails.push(obj);
      });
      this.validationSummary = [];
      if (payload.PaymentMethod === "") {
        this.validationSummary.push({
          message: "Payment Method is Required",
        });
        return;
      }
      if (payload.CustomerReceiptDetails.length === 0) {
        this.validationSummary.push({
          message:
            "Customer Receipt has no detail.  Please include one or more invoices before attempting to save the transaction again.",
        });
        return;
      } else if (this.dataModel.footerBalance != 0) {
        this.validationSummary.push({
          message:
            "Customer Receipt must balance to 0.00.Please check the amount received and the sum of the invoices included in the receipt before attempting to save the transaction again.",
        });
        return;
      }
      this.setLoading = true;
      await CustomerReceiptService.saveCustomerReceipt(payload)
        .then(({ data }) => {
          if (data) this.setLoading = false;
          this.$notify(
            `Customer Receipt ${data.Code} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: `/create-customer-receipt/review/${data.Code}`,
            })
            .then(() => {
              this.reload = true;
              this.initialized();
            });
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Customer Receipt save failed",
            time: new Date().getTime(),
          };
          this.setLoading = false;
        });
    },

    createCustomerReceiptDetailPostProcess(data) {
      data.forEach((element) => {
        element.CheckInclude = !this.isNavigatedFromCutomerPage();

        element.AllocatedAmount = (
          element.FXBalance.roundNumber(2) -
          element.DiscountReceived.roundNumber(2)
        ).roundNumber(2);

        if (
          this.IsSettlementDateEnforced == "Yes" &&
          new Date(element.CalculatedDueDate).valueOf() < this.dataModel.Date
        ) {
          element.FXDiscountReceived = 0;
        }
      });
      return data;
    },
  },
};
</script>
